import { InjectionToken, Type } from "@angular/core";

import { ParagraphDeprecated } from "@hermes/api-model-editorial";

export const CHAPTERS_PARAGRAPH = new InjectionToken<ParagraphDeprecated>(
    "ChaptersParagraph",
);

export const CHAPTERS_COMPONENT = new InjectionToken<Type<unknown>>(
    "ChaptersComponent",
);

export const SHOULD_PRELOAD_MEDIA = new InjectionToken<boolean>(
    "ChaptersshouldPreloadMedia",
);

export const IS_FIRST_PARAGRAPH = new InjectionToken<boolean>(
    "ChaptersIsFirstParagraph",
);
